import { library } from '@fortawesome/fontawesome-svg-core'
import { faCcVisa, faCcMastercard, faCcAmex, faStripe } from '@fortawesome/free-brands-svg-icons'
import {
  faLink,
  faUnlink,
  faPowerOff,
  faUser,
  faBuilding,
  faPhone,
  faPhoneSlash,
  faPhoneAlt,
  faChartBar,
  faClock,
  faStar,
  faChartPie,
  faUsers,
  faComments,
  faStickyNote,
  faPaperPlane,
  faInfoCircle,
  faChartLine,
  faCalendarAlt,
  faFilter,
  faSearch,
  faList,
  faHashtag,
  faSortUp,
  faSortDown,
  faThumbsUp,
  faThumbsDown,
  faQuestion,
  faQuestionCircle,
  faSort,
  faBook,
  faCog,
  faExclamationTriangle,
  faExclamationCircle,
  faHome,
  faPlug,
  faPlusCircle,
  faCheckCircle,
  faTimesCircle,
  faFileAlt,
  faTachometerAlt,
  faClipboardCheck,
  faBrain,
  faRobot,
  faLightbulb,
  faPen,
  faComment,
  faCommentDots,
  faExpand,
  faTimes,
  faChevronDown,
  faChevronUp,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faSlidersH,
  faMinus,
  faCheck,
  faDownload,
  faUserCheck,
  faEdit,
  faClipboard,
  faAt,
  faSpellCheck,
  faRedo,
  faHistory,
  faListAlt,
  faToggleOn,
  faToggleOff,
  faChevronLeft,
  faChevronRight,
  faBars,
  faSignOutAlt,
  faTh,
  faBug,
  faSync,
  faEye,
  faEyeSlash,
  faExternalLinkAlt,
  faChartArea,
  faDatabase,
  faClipboardList,
  faBullhorn,
  faCreditCard,
  faFileInvoiceDollar,
  faMoneyBillWave,
  faUniversity,
  faArrowLeft,
  faEllipsisV,
  faTrashAlt,
  faFilePdf,
  faCheckDouble,
  faPlus,
  faBriefcase,
  faFileInvoice,
  faPlayCircle,
  faUpload,
  faEnvelopeOpen,
  faEnvelope,
  faUserSlash,
  faCircleNotch,
  faBan,
  faSyncAlt,
  faShieldAlt,
  faBolt,
} from '@fortawesome/free-solid-svg-icons'

function initFontAwesome() {
  library.add(
    faLink,
    faUnlink,
    faUser,
    faPowerOff,
    faBuilding,
    faPhone,
    faPhoneSlash,
    faPhoneAlt,
    faChartBar,
    faClock,
    faStar,
    faChartPie,
    faUsers,
    faComments,
    faStickyNote,
    faPaperPlane,
    faInfoCircle,
    faChartLine,
    faCalendarAlt,
    faFilter,
    faSearch,
    faList,
    faHashtag,
    faSortUp,
    faSortDown,
    faThumbsUp,
    faThumbsDown,
    faQuestion,
    faQuestionCircle,
    faSort,
    faBook,
    faCog,
    faExclamationTriangle,
    faExclamationCircle,
    faHome,
    faPlug,
    faPlusCircle,
    faCheckCircle,
    faTimesCircle,
    faFileAlt,
    faTachometerAlt,
    faClipboardCheck,
    faBrain,
    faRobot,
    faLightbulb,
    faPen,
    faComment,
    faCommentDots,
    faExpand,
    faTimes,
    faChevronDown,
    faChevronUp,
    faArrowUp,
    faArrowDown,
    faArrowRight,
    faSlidersH,
    faMinus,
    faCheck,
    faDownload,
    faUserCheck,
    faEdit,
    faClipboard,
    faAt,
    faSpellCheck,
    faRedo,
    faHistory,
    faListAlt,
    faToggleOn,
    faToggleOff,
    faChevronLeft,
    faChevronRight,
    faBars,
    faSignOutAlt,
    faTh,
    faBug,
    faSync,
    faEye,
    faEyeSlash,
    faExternalLinkAlt,
    faChartArea,
    faDatabase,
    faClipboardList,
    faBullhorn,
    faCreditCard,
    faFileInvoiceDollar,
    faMoneyBillWave,
    faUniversity,
    faArrowLeft,
    faEllipsisV,
    faTrashAlt,
    faFilePdf,
    faCheckDouble,
    faPlus,
    faBriefcase,
    faFileInvoice,
    faPlayCircle,
    faUpload,
    faEnvelopeOpen,
    faEnvelope,
    faUserSlash,
    faCircleNotch,
    faBan,
    faSyncAlt,
    faShieldAlt,
    faBolt,
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faStripe,
  )
}

export default initFontAwesome
